import { render, staticRenderFns } from "./index.vue?vue&type=template&id=634a053e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634a053e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('634a053e')) {
      api.createRecord('634a053e', component.options)
    } else {
      api.reload('634a053e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=634a053e&scoped=true", function () {
      api.rerender('634a053e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hdybnbiotzcb/index.vue"
export default component.exports